<template>
  <label class="flex items-center gap-3 cursor-pointer">
    <input
      type="checkbox"
      class="checkbox checkbox-primary"
      :checked="modelValue"
      @change="onChange"
    />
    <span class="text-sm font-medium">{{ label }}</span>
  </label>
</template>


<script setup lang="ts">
defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:modelValue"]);

function onChange(event: Event) {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.checked);
}
</script>
